import React, { useEffect, useState } from "react";
import { Container, Button, Table, Form } from "react-bootstrap";
import axios from "axios";
import './Greetings.css'; // Reuse your layout styles

const Events = () => {
  const [eventName, setEventName] = useState("");
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const district = sessionStorage.getItem("userDistrict");

  const handleLogout = () => {
    sessionStorage.clear();
    window.location.href = '/';
  };

  const fetchEvents = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`https://lionsnewsapi.emedha.in/admin/api/events?district=${district}`);
      setEvents(response.data);
    } catch (error) {
      console.error("Error fetching events:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!eventName.trim()) return;
    try {
      await axios.post("https://lionsnewsapi.emedha.in/admin/api/events", {
        event_name: eventName.trim(),
        district
      });
      setEventName("");
      fetchEvents(); // Refresh list
    } catch (error) {
      console.error("Error posting event:", error);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, [district]);

  return (
    <div className="dashboard-layout">
      {/* Sidebar */}
      <div className="sidebar-nav">
        <h2>Menu</h2>
        <ul>
          <li><button className="side-button" onClick={() => window.location.href = '/Dashboard'}>Posts</button></li>
          <li><button className="side-button" onClick={() => window.location.href = '/greetings'}>Greetings</button></li>
          <li><button className="side-button" onClick={() => window.location.href = '/events'}>Event Photos</button></li>
          <li><button className="side-button" onClick={() => window.location.href = '/profile'}>Verified Profile</button></li>
          <li><button className="side-button" onClick={handleLogout}>LogOut</button></li>
        </ul>
      </div>

      {/* Main Content */}
<div
  className="content-section"
  style={{
    padding: "30px",
    backgroundColor: "#f9f9f9",
    borderRadius: "8px",
    flexGrow: 1,
  }}
>
  <h1
    className="page-title"
    style={{ fontWeight: "bold", fontSize: "24px", color: "#333", marginBottom: "24px" }}
  >
    Events - District {district}
  </h1>


 <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "16px",
      marginBottom: "30px",
      flexWrap: "wrap",
    }}
  >
    <Form.Control
      type="text"
      value={eventName}
      onChange={(e) => setEventName(e.target.value)}
      placeholder="Eventname"
      style={{
    // input grows but min 300px
        padding: "10px",
        fontSize: "16px",
        width: "300px",
      }}
    />
    <Button
      type="submit"
      variant="primary"
      style={{
        width: "120px",
        padding: "10px",
        fontSize: "16px",
      }}
      disabled={!eventName.trim()}
    >
      Add Event
    </Button>
  </div>
</Form>


  {loading ? (
    <p>Loading events...</p>
  ) : (
    <Table striped bordered hover responsive style={{ backgroundColor: "#fff" }}>
      <thead style={{ backgroundColor: "#343a40", color: "#fff" }}>
        <tr>
          <th>ID</th>
          <th>Event Name</th>
          <th>District</th>
        </tr>
      </thead>
      <tbody>
        {events.map((ev) => (
          <tr key={ev.id}>
            <td>{ev.id}</td>
            <td>{ev.event_name}</td>
            <td>{ev.district}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  )}
</div>


    </div>
  );
};

export default Events;
